export default {
  title: 'Beloningen',
  guest: {
    eyebrow: 'Beloningen',
    headline: 'Elke bestelling levert je <highlight>beloningen</highlight> op',
    subheading_one: 'Verdien {{count}} punt per {{amount}} besteed.',
    subheading_other: 'Verdien {{count}} punten per {{amount}} besteed.',
    cta: 'Aanmelden & beginnen met verdienen',
    already_member: 'Al lid?',
    sign_in: 'Inloggen',
    redeemable_heading: 'Jouw punten = gratis eten',
    redeemable_eyebrow: '🎁 Beloningen die je vrijspeelt',
  },
  member: {
    balance_label: 'Jouw saldo',
    balance_suffix: 'punten · waard <highlight>{{amount}}</highlight>',
    next_reward: 'Volgende beloning bij <highlight>{{points}} pts</highlight>',
    redeem_hint: '✓ Je kunt tot {{points}} pts ({{amount}}) inwisselen op je volgende bestelling',
    expiration_zero: '⏳ {{points}} pts verlopen vandaag',
    expiration_one: '⏳ {{points}} pts verlopen over 1 dag',
    expiration_other: '⏳ {{points}} pts verlopen over {{count}} dagen',
    pts_lifetime: 'Pts levensduur',
    saved_lifetime: 'Totaal bespaard',
    cta: 'Nu bestellen',
    redeemable_heading: 'Wat je kunt inwisselen',
    redeemable_eyebrow: 'Je hebt {{points}} pts ({{amount}})',
    redeemable_description:
      'Tot {{maxPoints}} pts ({{maxAmount}}) per bestelling. Items onder {{maxAmount}} zijn volledig gratis.',
  },
  items: {
    free: 'GRATIS',
    save: 'Bespaar {{amount}}',
  },
  history: {
    eyebrow: 'Geschiedenis',
    title: 'Recente activiteit',
    load_more: 'Meer laden',
    sources: {
      welcome_bonus: 'Welkomstbonus',
      google_review_reward: 'Google-reviewbeloning',
      reward_loyalty_program_conversion: 'Loyaliteitsprogramma-conversie',
      cashback: 'Cashback verdiend',
      refund: 'Bestelling terugbetaald',
      cashback_usage: 'Punten ingewisseld',
      cashback_usage_refund: 'Inwisseling terugbetaald',
      expired_points_void: 'Punten verlopen',
      mobile_app_signup_bonus: 'Aanmeldbonus mobiele app',
    },
    detail_with_order: 'Bestelling #{{number}} · {{amount}}',
  },
  how_it_works: {
    eyebrow_guest: 'Eenvoudig & automatisch',
    eyebrow_member: 'Korte herinnering',
    title: 'Hoe het werkt',
    steps: {
      sign_up: {
        emoji: '📲',
        title: 'Gratis aanmelden',
        desc: 'Maak een account aan in 30 seconden.',
      },
      order: {
        emoji: '🍔',
        title: 'Bestel & verdien',
        desc_one: '1 pt per {{amount}} — automatisch bijgehouden.',
        desc_other: '{{count}} pt per {{amount}} — automatisch bijgehouden.',
      },
      build: {
        emoji: '⭐',
        title: 'Punten verzamelen',
        desc: 'Inwisselen vanaf {{minPoints}} pt. Geldig {{lifetime}} dagen.',
      },
      save: {
        emoji: '🎁',
        title: 'Bespaar bij het afrekenen',
        desc: 'Tot {{maxAmount}} korting — direct toegepast.',
      },
      repeat: {
        emoji: '🔄',
        title: 'Herhaal & bespaar',
        desc: 'Elke bestelling vergroot je saldo.',
      },
    },
  },
  faq: {
    eyebrow: 'Vragen?',
    title: 'Veelgestelde vragen',
    items: {
      earn: {
        q: 'Hoe verdien ik punten?',
        a_one:
          'Je verdient 1 punt voor elke {{amount}} die je besteedt. Punten worden na elke bestelling automatisch aan je account toegevoegd — geen scannen of codes nodig.',
        a_other:
          'Je verdient {{count}} punten voor elke {{amount}} die je besteedt. Punten worden na elke bestelling automatisch aan je account toegevoegd — geen scannen of codes nodig.',
      },
      redeem: {
        q: 'Wanneer kan ik beginnen met inwisselen?',
        a: 'Je kunt beginnen met inwisselen zodra je {{minPoints}} punten hebt. Gebruik ze bij het afrekenen om je totaalbedrag te verlagen.',
      },
      max: {
        q: 'Hoeveel kan ik per bestelling besparen?',
        a: 'Je kunt tot {{maxPoints}} punten ({{maxAmount}}) per bestelling inwisselen. Dat is de maximale korting die je bij één afrekening kunt toepassen.',
      },
      validity: {
        q: 'Hoe lang zijn punten geldig?',
        a: 'Punten zijn geldig voor {{lifetime}} dagen vanaf het moment dat ze zijn verdiend. Gebruik ze voordat ze verlopen!',
      },
    },
  },
};
